import { render } from "./my-preview.vue?vue&type=template&id=33b21a72"
import script from "./my-preview.vue?vue&type=script&lang=js"
export * from "./my-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__